export default __webpack_public_path__ + "static/media/earnie_detective.8c7f4198.png";